<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card class="mx-auto text-center" color="blue-grey" dark>
          <div align="center">
            通用門受付
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="left">
        <v-card class="mx-auto text-left pl-2" color="white">
          <div><span class="orange--text">読込用ボックス</span>をクリックした状態でUSBバーコードスキャナから入力するか、</div>
          <div><span class="orange--text">虫眼鏡ボタン</span>をクリックして生徒検索・選択して、読込してください。</div>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense align="center">
      <v-col cols="12" justify="center">
        <!-- 連絡ブロック -->
        <v-card
          class="d-flex justify-center flex-column mx-auto flat"
          color="#fff"
        >
          <v-card-title>
            <v-row dense>
              <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                <v-btn-toggle
                  v-model="syukketuKbn"
                  @change="changeSyukketuKbn"
                  mandatory
                >
                  <v-btn large active-class="red--text" value="chikoku">
                    <v-icon x-large left>
                      mdi-location-enter
                    </v-icon>
                    <span>遅刻</span>
                  </v-btn>
                  <v-btn large active-class="blue--text" value="sotai">
                    <span>早退</span>
                    <v-icon x-large right>
                      mdi-location-exit
                    </v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col cols="12" sm="12" md="10" lg="10" xl="10" class="d-flex">
                <v-text-field
                  v-model="inputCode"
                  ref="box"
                  label="読込用ボックス(学籍番号)"
                  placeholder=""
                  outlined
                  dense
                  :disabled="isReading"
                  background-color="orange lighten-3"
                  @keydown.enter="changeInputCode"
                  append-icon="mdi-barcode-scan"
                  hide-details="auto"
                />
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="orange" class="ml-2" v-bind="attrs" v-on="on" icon outlined @click="barCodeCheckInSearchFlg = true"><v-icon>mdi-magnify</v-icon></v-btn>
                  </template>
                  <span>生徒検索画面を開く</span>
                </v-tooltip>
                <v-btn
                  depressed
                  :disabled="!isSuccess"
                  class="ml-2"
                  color="green"
                >
                  成功
                </v-btn>
                <v-btn
                  depressed
                  :disabled="!isError"
                  class="ml-2"
                  color="red"
                >
                  エラー
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="d-flex justify-center">
            <v-row dense>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" justify="center">
                <v-text-field
                  v-model="cacheCode"
                  label="前回読込コード"
                  outlined
                  dense
                  disabled
                  append-icon="mdi-lock-outline"
                  hide-details="auto"
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" justify="center">
                <v-text-field
                  v-model="studentName"
                  label="読込生徒名"
                  outlined
                  dense
                  disabled
                  append-icon="mdi-account"
                  hide-details="auto"
                  >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="history"
          :items-per-page="-1"
          :footer-props="{'disable-items-per-page': true}"
          dense
          disable-sort          
          :loading="isListLoding" loading-text="読込中"
        >
          <template #[`header.syukketuKbn`]="{}"> 
            <v-row dense><v-col cols="12" justify="center">
              課程/部/科
            </v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">
              学年/学級/出席番号
            </v-col></v-row>
          </template>
          <template #[`item.syukketuKbn`]="{ item }">
            <v-row dense><v-col cols="12" justify="center">
              <span v-if="!item.errorFlg">{{ item.kateiNm }}/{{ item.buNm }}/{{ item.kaNm }}</span>
            </v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">
              <span v-if="!item.errorFlg">{{ item.gakunen }}/{{ item.gakkyu }}/{{ item.syussekiNo }}</span>
            </v-col></v-row>
          </template>
          <template #[`item.errorFlg`]="{ item }">
            <span v-if="item.errorFlg" class="red--text">処理失敗</span>
            <span v-else class="green--text">処理成功</span>
          </template>
          <template #[`item.message`]="{ item }">
            <span v-if="item.errorFlg" class="red--text">{{ item.message }}</span>
            <span v-else>{{ item.message }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- 検索機能モーダル -->
    <v-dialog
      v-model="barCodeCheckInSearchFlg"
      max-width="700"
      min-height="500"
      max-height="500"
      persistent
      scrollable
    >
      <ValidationObserver ref="obs" v-slot="{ invalid }">
        <v-card
          class="d-flex flex-column mx-auto my-auto flat"
          color="#fff"
          max-width="680"
          min-height="500"
          max-height="500"
        >
          <v-card-actions class="my-0">
            <v-row dense>
              <v-col cols="2" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small v-bind="attrs" v-on="on" color="grey" @click="closeBarCodeCheckIn()">
                      <v-icon color="white">mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>閉じる</span>
                </v-tooltip>
              </v-col>
              <v-col cols="8" class="d-flex justify-center">
                全生徒検索
              </v-col>
              <v-col cols="2" justify="center">
              </v-col>
            </v-row>
          </v-card-actions>
          <!-- 検索条件 -->
          <v-card-text class="d-flex flex-column pb-0">
            <v-row dense>
              <v-col cols="10">
                <ValidationProvider name="検索ワード" rules="required|max:500" v-slot="{ errors }" :skipIfEmpty="false">
                  <v-text-field
                      v-model="modalStudentName"
                      label="検索ワード(氏名もしくはカナ(半角)の部分一致)"
                      placeholder="検索ワード(氏名もしくはカナ(半角)の部分一致)"
                      prepend-icon="$cet_required"
                      :error-messages="errors[0]"
                      outlined
                      dense
                      :counter="500"
                      hide-details="auto"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="2">
                <v-btn color="accent" class="ml-2 black--text" :disabled="invalid" @click="clickSearchModal(modalStudentName)">
                  検索
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- 検索結果 -->
          <v-card-text class="d-flex flex-column pt-0">
            <v-row dense>
              <v-col dense cols="12" justify="center">
                <v-data-table
                  :headers="modalHeaders"
                  :items="members"
                  :items-per-page="6"
                  :footer-props="{'disable-items-per-page': true, 'items-per-page-options': [6, -1]}"
                  dense
                  disable-sort
                  mobile-breakpoint="0"
                  :loading="isModalLoding" loading-text="読込中"
                >
                  <template #[`modalHeaders.recode`]="{}">
                    <v-row no-gutters><v-col cols="12">課程/部/科</v-col></v-row>
                    <v-row no-gutters><v-col cols="12">学年/学級/出席番号</v-col></v-row>
                    <v-row no-gutters><v-col cols="12">氏名</v-col></v-row>
                  </template>

                  <template #[`item.recode`]="{ item }">
                    <v-row no-gutters class="hidden-xs-only"><v-col cols="12">
                      {{ item.kateiNm }}/{{ item.buNm }}/{{ item.kaNm }}
                    </v-col></v-row>
                    <v-row no-gutters class="hidden-xs-only"><v-col cols="12">
                      {{ item.gakunen }}/{{ item.gakkyu }}/{{ item.syussekiNo }}
                    </v-col></v-row>

                    <!-- モバイル用まとめ -->
                    <v-row no-gutters class="d-sm-none">
                      <v-col cols="12">
                        {{ item.kateiNm }}/{{ item.buNm }}/{{ item.kaNm }}/{{ item.gakunen }}/{{ item.gakkyu }}/{{ item.syussekiNo }}
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="d-sm-none">
                      <v-col cols="2" class="d-flex justify-center">
                        <v-btn color="green" small class="black--text mx-2" @click="selectBarCodeCheckIn(item)">選択</v-btn>                                        
                      </v-col>
                      <v-col cols="10">
                        {{ item.userNm }}({{ item.userNmKana }})
                      </v-col>
                    </v-row>
                  </template>

                  <!-- 氏名(ｶﾅ) -->
                  <template #[`item.userNm`]="{ item }">
                    <v-row no-gutters>
                      <v-col cols="12">
                        {{ item.userNm }}({{ item.userNmKana }})
                      </v-col>
                    </v-row>
                  </template> 
                  <!-- 選択 -->
                  <template #[`item.action`]="{ item }">
                    <v-row no-gutters>
                      <v-col cols="6" class="d-flex justify-center">
                        <v-btn color="green" small class="black--text mx-2" @click="selectBarCodeCheckIn(item)">選択</v-btn>                                        
                      </v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      </ValidationObserver>
    </v-dialog>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>再読込</span>
    </v-tooltip>

    <v-snackbar
      v-model="viewResultBar"
      timeout="-1"
      top
    >
      処理中
    </v-snackbar>
  </v-container>
</template>

<script>
import { httpsCallable, getFunctions } from "firebase/functions";
export default {
  data() {
    return {
      headers: [
        { text: "読込時刻", value: "postDate", width: "15%" },
        { text: "読込コード", value: "barcode", width: "10%" },
        { text: "生徒氏名(カナ)", value: "studentName", width: "20%" },
        { text: "課程/部/科 学年/学級/出席番号", value: "syukketuKbn", width: "20%", filter: this.syukketuKbnFilter },
        { text: "ステータス", value: "errorFlg", width: "10%" },
        { text: "処理結果", value: "message", width: "25%" },
      ],
      history: [],
      isListLoding: false,

      syukketuKbn: "chikoku",
      // 読込用ボックス
      inputCode : "",
      isReading: false,
      // 前回読込コード
      cacheCode : "",
      viewResultBar: false,
      // 成功判定表示用
      isSuccess : false,
      isError : false,
      // 生徒検索画面 氏名ｶﾅ
      modalStudentName : "",
      // 生徒検索モーダル表示フラグ
      barCodeCheckInSearchFlg : false,
      // 生徒検索モーダル ロード 
      isModalLoding: false,
      // 生徒検索モーダル 検索ボタン
      isSearchButtonDisabled: true,
      // 生徒検索モーダル ヘッダー
      modalHeaders: [
        { text: "選択", value: "action", class: "px-0 hidden-xs-only", cellClass: "hidden-xs-only", width: "10%"},    
        { text: "課程/部/科/学年/学級/出席番号", value: "recode", class: "px-0 hidden-xs-only", width: "40%"},
        { text: "氏名(ｶﾅ)", value: "userNm", class: "px-0 hidden-xs-only", cellClass: "hidden-xs-only", width: "50%"},  
      ], 
      members: [],
    };
  },

  // 初期表示時データ読み込み
  created() {
    this.syukketuKbn = this.$store.state.selectBarCodeSyukketuKbn;
    this.$nextTick(() => this.$refs.box.focus());
    this.reload();
  },
  watch: {
    syukketuKbn: function(newVal) {this.$store.dispatch('setSelectBarCodeSyukketuKbn', newVal)},
  },
  methods: {
    // 画面初期表示時
    async reload() {
      // 読取状況の取得
      this.isListLoding = true;
      this.history = [];
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined({funcName: "loadBarcodeCheckIn"}).then((ret) => {
        this.history = ret.data;
      });
      this.isListLoding = false;
    },
    // 出欠区分の変更
    async changeSyukketuKbn() {
      this.inputCode = "";
      this.cacheCode = "";
      this.studentName = "";
      this.isSuccess = false;
      this.isError = false;
    },
    // 出欠区分フィルタ
    syukketuKbnFilter(value) {
      return this.syukketuKbn === value;
    },
    // バーコード読込時
    async changeInputCode() {
      // 空の場合無視する
      if(!this.inputCode)return;
      // 読取ロックの設定
      this.isReading = true;
      this.viewResultBar = true;

      // 全角入力を半角に変換
      var barcode = this.inputCode;
      const fullnums = '０１２３４５６７８９';
      const toHalfnums = text => text.replace(/[０-９]/g, m=>fullnums.indexOf(m));
      this.inputCode = toHalfnums(barcode);

      // サーバー処理
      var param = {
        funcName: "checkInBarCode",
        syukketuKbn: this.syukketuKbn,
        barcode: this.inputCode,
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
  
        // 成功 or エラー表示切替
        if(!ret.data.errorFlg) {
          this.isSuccess = true;
          this.isError = false;
        } else {
          this.isSuccess = false;
          this.isError = true;
        }

        // 読取値の退避
        this.cacheCode = this.inputCode;
        // 生徒名の設定
        this.studentName = ret.data.studentName;
      });

      // 読み取り値の初期化
      this.inputCode = "";
      // 読取ロックの解除
      this.isReading = false;
      this.viewResultBar = false;
      this.$nextTick(() => this.$refs.box.focus());
      
      // 処理後に再表示
      this.reload();
    },

    // 検索ボタン押下
    async clickSearchModal(value) {
      // 読取状況の取得
      this.isModalLoding = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      var data = {
        funcName : "searchStudentInfo",
        studentNm : value
      }
      await schoolAidHomeLogined(data).then((ret) => {
        console.log(ret);
        var buff = [];
        ret.data.forEach((user) => {
            var row = {
                userNm: user.userNm,
                userNmKana: user.userNmKana,
                kateiNm: user.kateiNm,
                buNm: user.buNm,
                kaNm: user.kaNm,
                gakunen: user.gakunen,
                gakkyu: user.gakkyu,
                syussekiNo: user.syussekiNo,
                gakusekiCd : user.gakusekiCd
            };
            buff.push(row);
        });
        this.members = buff;
      });
      this.isModalLoding = false;      
    },

    // 選択ボタンの押下
    async selectBarCodeCheckIn(item) {
      // 読取ロックの設定
      this.isReading = true;
      this.viewResultBar = true;

      // 全角入力を半角に変換
      var barcode = item.gakusekiCd;
      const fullnums = '０１２３４５６７８９';
      const toHalfnums = text => text.replace(/[０-９]/g, m=>fullnums.indexOf(m));
      this.inputCode = toHalfnums(barcode);

      // サーバー処理
      var param = {
        funcName: "checkInBarCode",
        syukketuKbn: this.syukketuKbn,
        barcode: this.inputCode,
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
  
        // 成功 or エラー表示切替
        if(!ret.data.errorFlg) {
          this.isSuccess = true;
          this.isError = false;
        } else {
          this.isSuccess = false;
          this.isError = true;
        }

        // 読取値の退避
        this.cacheCode = this.inputCode;
        // 生徒名の設定
        this.studentName = ret.data.studentName;
      });

      // 読み取り値の初期化
      this.inputCode = "";
      // 読取ロックの解除
      this.isReading = false;
      this.viewResultBar = false;
      this.$nextTick(() => this.$refs.box.focus());
      
      // 初期化
      this.modalStudentName = "";
      // 検索結果初期化
      this.members = [];
      // モーダルを閉じる
      this.barCodeCheckInSearchFlg = false;
      // 処理後に再表示
      this.reload();
    },

    // 閉じるボタン
    async closeBarCodeCheckIn() {
      // 入力値初期化
      this.modalStudentName = "";
      // 検索結果初期化
      this.members = [];
      // モーダルを閉じる
      this.barCodeCheckInSearchFlg = false;
    }
  }
};
</script>